import { BusinessGroup } from "../models/BusinessGroup";
import { IndoorExperience } from "../models/IndoorExperience";

export const GET_MY_BUSINESS_GROUPS = "GET_MY_BUSINESS_GROUPS";
export const SELECT_CURRENT_BUSINESS_GROUPS = "SELECT_CURRENT_BUSINESS_GROUPS";
export const SELECT_CURRENT_INDOOR = "SELECT_CURRENT_INDOOR";
export const CREATE_BEACON_GROUP = "CREATE_BEACON_GROUP";

export interface GetBusinessGroups {
  type: typeof GET_MY_BUSINESS_GROUPS;
  experiencePayload: Array<BusinessGroup> | undefined;
  indoorPayload: Array<IndoorExperience> | undefined;
}

export interface SelectCurrentBusinessGroups {
  type: typeof SELECT_CURRENT_BUSINESS_GROUPS;
  payload: BusinessGroup | null | undefined;
}

export interface SelectCurrentIndoor {
  type: typeof SELECT_CURRENT_INDOOR;
  payload: IndoorExperience | null | undefined;
}

export interface CreateBeaconGroup {
  type: typeof CREATE_BEACON_GROUP;
  payload: undefined | null;
}

export type BusinessGroupActions =
  | GetBusinessGroups
  | SelectCurrentBusinessGroups
  | SelectCurrentIndoor
  | CreateBeaconGroup;
